<h2 class="sidenav-heading mt-0">
  <ng-content></ng-content>
</h2>
<nav [attr.aria-label]="'sidenavigation.label' | translate" *ngIf="links.length > 0">
  <ul>
    <ng-container *ngFor="let link of links; trackBy: trackBy; let i = index">
      <li *ngIf="link.routerLink || (!link.routerLink && link.children && link.showChildren)">
        <ng-container *ngTemplateOutlet="menuLink; context: { link: link, index: i, parent: null }">
        </ng-container>
      </li>
    </ng-container>
  </ul>
</nav>

<ng-template #menuLink let-link="link" let-parent="parent" let-index="index">
  <a *ngIf="link.routerLink && (!link.children || !link.showChildren)" [attr.aria-current]="link?.current ? 'page' : null" [class.d-block]="link?.children && link?.showChildren" [attr.aria-expanded]="link?.children !== undefined && link?.showChildren ? link?.expanded ?? 'false' : null" [routerLink]="urlPrefix + link.routerLink" (click)="onItemClick(link, index, parent)">
    {{ link?.title | translate }}
  </a>
  <button *ngIf="link.children && link.showChildren" [attr.aria-current]="link?.current ? 'page' : null" [attr.aria-expanded]="link?.children !== undefined && link?.showChildren ? link?.expanded ?? 'false' : null" (click)="onItemClick(link, index, parent)">
    {{ link?.title | translate }}
  </button>
  <ul *ngIf="link?.showChildren && link?.children && parent === null" [attr.aria-hidden]="!link?.expanded">
    <li *ngFor="let child of link?.children">
      <ng-container *ngTemplateOutlet="menuLink; context: { link: child, index: index, parent: parent }">
      </ng-container>
    </li>
  </ul>
</ng-template>
